module.exports = __webpack_public_path__ + "build/img/demis-digital.ce75ad60.png";